<template>
  <q-item
    :class="{'archived': isArchived, 'draft': isDraft, 'update-available': isUpdatePending}"
    :active="selected"
    :clickable="!selected"
    class="form-revision"
    @click="$emit('click')"
  >
    <q-item-section>
      <q-item-label
        v-if="withTitle"
        :title="revision.title"
        caption
        class="text-bold"
      >
        {{ truncateString(revision.title, 50) }}
      </q-item-label>
      <q-item-label
        class="text-weight-bold"
        :class="{'text-grey-8': !isBeta, 'text-orange-9': isBeta}"
      >
        <template v-if="revision.is_master">
          <q-icon name="mdi-hat-fedora" /> Master Copy
        </template>
        <template v-else>
          Edited Copy
        </template>

        <q-chip
          v-if="isBeta"
          dense
          dark
          size="12px"
          class="q-my-none"
          color="orange-9"
        >
          Beta
        </q-chip>
        <q-chip
          v-if="isUpdatePending || isDraft"
          dense
          dark
          size="12px"
          class="q-my-none"
          :color="dominantColor"
        >
          {{ isUpdatePending ? 'Update' : 'Draft' }}
        </q-chip>
      </q-item-label>
      <q-item-label caption>
        Version {{ revision.master_version }}.{{ revision.minor_version }}
      </q-item-label>
      <q-item-label
        v-if="isUpdatePending"
        class="text-bold"
      >
        This revision cannot be used until it is enabled.
      </q-item-label>
    </q-item-section>
    <q-item-section
      v-if="!withoutTimestamp && (isVisible || isDraft)"
      side
      class="gt-xs"
    >
      <q-item-label caption>
        {{ $formatSystemDate(revision.created_at, luxonFormats.FRIENDLY_DATE_TIME) }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
    >
      <q-btn
        dense
        round
        size="sm"
        icon="mdi-chevron-right"
        class="no-pointer-events"
        :class="{'hidden': selected}"
        :color="dominantColor"
      />
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  props: {
    revision: {
      type: Object,
      required: true
    },
    // If a form has been selected, disable clicking it
    selected: {
      type: Boolean,
      default: false
    },
    // Hide revision date
    withoutTimestamp: {
      type: Boolean,
      default: false
    },
    // Display the title (only useful if the revision's title differs from the group title
    withTitle: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    isArchived () {
      return this.revision.status === 'ARCHIVED'
    },
    isDraft () {
      return this.revision.status === 'DRAFT'
    },
    isVisible () {
      return this.revision.status === 'VISIBLE'
    },
    isBeta () {
      return this.revision.is_beta
    },
    isUpdatePending () {
      return this.revision.status === 'UPDATE_PENDING'
    },
    dominantColor () {
      switch (this.revision.status) {
        case 'UPDATE_PENDING': return 'orange-10'
        case 'ARCHIVED': return 'red-7'
        case 'DRAFT': return 'blue-grey-7'
      }
      return 'blue-7'
    }
  }
}
</script>
